import React from "react";
import { Typography, Button, Tag } from "antd";
import { Views } from "react-big-calendar";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import OrdersList from "../../../components/scheduling/OrdersList";
import { getActiveOrders } from "../../../components/util/helpers";
import { useIntl } from "react-intl";

const { Title } = Typography;

const Header = (props) => {
  const {
    calenderView,
    currentDate,
    effective_orders,
    order_time_extractions,
    ordersPalette,
    onFilterOrdersChanged,
    onNextDate,
    onPreviousDate,
    events,
    showApproved,
    filteredOrders,
  } = props;
  const intl = useIntl();
  let date =
    calenderView === Views.DAY
      ? moment(currentDate).format("LL")
      : calenderView === Views.WEEK
      ? `${moment(currentDate).startOf("week").format("LL")} - ${moment(
          currentDate
        )
          .endOf("week")
          .format("LL")}`
      : moment(currentDate).format("MMMM YYYY");
  date =
    calenderView === Views.DAY
      ? `${date} (${moment(currentDate).format("dddd")})`
      : date;
  const activeOrders = getActiveOrders(currentDate, effective_orders);
  const disabledNext =
    calenderView === Views.WEEK &&
    !moment(moment(currentDate).add(1, "week")).isSame(
      moment(currentDate),
      "month"
    );

  const disabledPrevious =
    calenderView === Views.WEEK &&
    !moment(moment(currentDate).subtract(1, "week")).isSame(
      moment(currentDate),
      "month"
    );

  const view =
    calenderView === Views.DAY
      ? "day"
      : calenderView === Views.WEEK
      ? "week"
      : "month";

  const effectiveEvents = events.filter(
    (i) =>
      moment(i.date) > moment(currentDate).startOf(view) &&
      moment(i.date) < moment(currentDate).endOf(view)
  );
  const total =
    Math.round(
      (effectiveEvents.reduce((a, b) => +a + +(b.duration_minutes || 0), 0) /
        60) *
        100
    ) / 100;
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
          width:
            calenderView === Views.MONTH
              ? "200px"
              : calenderView === Views.WEEK
              ? "430px"
              : "330px",
          flexShrink: 0, // Prevent this section from shrinking
        }}
      >
        <Tag style={{ margin: 0 }}>
          {`${total} ${intl.formatMessage({
            id: "app.scheduling.totalSceduledHours",
          })}`}
        </Tag>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          <Button
            type="text"
            shape="circle"
            icon={<RightOutlined />}
            onClick={onPreviousDate}
            disabled={disabledPrevious}
          />
          <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
            {date}
          </Title>
          <Button
            type="text"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={onNextDate}
            disabled={disabledNext}
          />
        </div>
      </div>
      <div
        style={{
          flex: 1,
          minWidth: 0, // Allow content to shrink below its minimum content size
          marginLeft: "10px",
          marginRight: "10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <OrdersList
          effective_orders={
            calenderView === Views.DAY ? activeOrders : effective_orders
          }
          order_time_extractions={order_time_extractions}
          ordersPalette={ordersPalette}
          onFilterOrdersChanged={onFilterOrdersChanged}
          mode={"scheduling"}
          events={events}
          showApproved={showApproved}
          filteredOrders={filteredOrders}
          currentDate={currentDate}
        />
      </div>
    </div>
  );
};

export default Header;
